/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

export class LoginDetails {
  public username: string | undefined = undefined;
  public password: string | undefined = undefined;
  public rememberMe: boolean | undefined = undefined;
}
